import Icon from "@/components/Ui/Icon";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/shadcn/tooltip";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type TooltipProps = {
  title?: string;
  description?: string;
  position?: "top" | "bottom";
  fixedWidth?: number;
  className?: string;
  children?: ReactNode;
};

const InfoTooltip = ({
  title,
  description,
  position = "top",
  fixedWidth,
  className,
  children,
}: TooltipProps) => {
  const content = children ?? (
    <>
      {title && <div className="mb-0.5 font-semibold">{title}</div>}
      {description && <div>{description}</div>}
    </>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className={twMerge(
            "bg-primary/30 text-muted-foreground row hover:bg-primary/40 hover:text-foreground ml-2 h-5 w-6 cursor-pointer rounded-sm border",
            className,
          )}
          aria-label="Open tooltip"
          type="button"
        >
          <Icon className="text-muted-foreground text-xs" name="i" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side={position}
        align="end"
        sideOffset={8}
        showArrow={false}
        className="bg-muted text-foreground max-w-sm p-4 text-sm text-pretty shadow-lg"
        style={
          fixedWidth ? { width: fixedWidth, maxWidth: fixedWidth } : undefined
        }
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
};

export default InfoTooltip;
